/* eslint-disable jsdoc/check-param-names */
import React from 'react';
import { Button } from '@mui/material';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { buttonsTheme } from './_theme.jsx';
import { BasePopup } from './BasePopup.jsx';
import { File } from 'olympe';
import { Image } from './Image.jsx';

/**
 * Template for the advanced search, displaying the image and buttons at the bottom
 * - Search fields are provided via the content prop
 * - The component can be displayed as a popup, or "fullscreen" (using its full width and height)
 * @param {React.ReactElement} content
 * @param {boolean} isFullScreen
 * @param {boolean} cannotApply
 * @param {function(): void} handleClose
 * @param {function(): void} handleClear
 * @param {File} image
 * @param {object} style
 * @returns {React.ReactElement}
 * @class
 */
// prettier-ignore
export const AdvancedSearchTemplate = ({searchFields, isFullScreen, cannotApply, handleClose, handleClear, image, style }) => {

	const fields = <div
		className={`advanced-search-content-container show-scrollbar ${isFullScreen ? 'advanced-search-content-container-fullscreen' : ''}`}
	>
		<Image
			imageFile={image}
			style={{
				width: '80%',
				minHeight: '300px',
				marginBottom: '57px'
			}}
		/>
		{searchFields}
	</div>;

	const buttons = <div className='advanced-search-button-container'>
		<Button
			color='primary'
			variant='contained'
			className='base-popup-button'
			style={{ marginRight: '21px' }}
			disabled={cannotApply}
			onClick={handleClose}
		>apply</Button>
		<Button
			color='secondary'
			variant='outlined'
			className='base-popup-button'
			onClick={handleClear}
		>clear</Button>
	</div>;

	if(isFullScreen) {
		return <ThemeProvider theme={buttonsTheme}>
			<div className='advanced-search-fullscreen-container' style={{}}>
				{fields}
				{buttons}
			</div>
		</ThemeProvider>;
	} else {
		return <BasePopup
				showTitleBanner={false}
				title=''
				style={{height: '80vh'}}
				content={fields}
				button={buttons}
				largeWidth={true}
				handleCloseDialog={handleClose}
			/>;
	}
}
